import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { fontWeights } from "et3-ui-library";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";

const SideBarStat = withLiteObserverAndTheme<{ label: string; value: string }>(
  (props) => {
    const { label, value } = props;

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          px: 1.5,
          py: 1,
          borderRadius: 1,
          bgcolor: "action.hover"
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
        <Typography
          variant="subtitle2"
          fontWeight={fontWeights.bold}
          sx={{ whiteSpace: "nowrap" }}
        >
          {value}
        </Typography>
      </Box>
    );
  }
);
export default SideBarStat;
